export default __webpack_public_path__ + "static/media/ic_manual.a3cda906.png";